import { render } from "./FrontDash.vue?vue&type=template&id=398cf50f"
import script from "./FrontDash.vue?vue&type=script&lang=js"
export * from "./FrontDash.vue?vue&type=script&lang=js"

import "./FrontDash.vue?vue&type=style&index=0&id=398cf50f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__